import type { DefaultProps, StyleProps } from '@design-system/types/props'
import styles from '@mathflat/common/style'
import { observer } from 'mobx-react'
import type { CSSProperties } from 'react'
import * as React from 'react'

import S from './_Badge.style'

export type Props = {
  theme?: 'twin' | 'autoScorable' | 'new' | 'private' | 'repProblem' | 'darkGray' | 'blue' | 'solid'
  size?: 'small' | 'large'
  color?: string

  children: DefaultProps['children']
  background?: CSSProperties['background']
  border?: boolean
  onClick?: React.MouseEventHandler<HTMLSpanElement>
} & StyleProps

const {
  colors: { gray },
} = styles

/**
 *
 * @deprecated
 */
const _Badge = ({
  size = 'small',
  theme,
  className,
  style,
  border,
  color = gray.$700,
  background = gray.$300,
  onClick,
  children,
}: Props) => {
  return (
    <span
      css={[
        S.defaultBadgeStyle,
        S.size[size],
        border && S.border,
        color && { color },
        background && { background },
        theme && S.theme[theme],
      ]}
      className={className}
      style={{ ...style }}
      onClick={onClick}
    >
      {children}
    </span>
  )
}
/**
 * @deprecated
 * 이 컴포넌트는 곧 Badge 컴포넌트로 대체될 예정입니다.
 *
 * Badge 컴포넌트 사용을 권장합니다.
 */
export default observer(_Badge)
